import React, { Component } from 'react';
import api from './api';
import { Link } from "react-router-dom";
import { Chart } from 'primereact/chart';
import { getAllMembers, getYouths } from './actions/memberActions';
class Home extends Component {
    constructor() {
        super();
        this.state = {
            male: "",
            female: "",
            maleYouths: "",
            femaleYouths: "",
            branchData: "",
            sectorData: "",
            institutionData: ""
        }
        this.getByGender = this.getByGender.bind(this);
        this.getYouthsByGender = this.getYouthsByGender.bind(this);
        this.getBranches = this.getBranches.bind(this);
        this.getSectors = this.getSectors.bind(this);
        this.getInstitutions = this.getInstitutions.bind(this);
        this.generateGenderChart = this.generateGenderChart.bind(this);
        this.generateYouthsGenderChart = this.generateYouthsGenderChart.bind(this);
        this.generateBranchChart = this.generateBranchChart.bind(this);
        this.generateSectorChart = this.generateSectorChart.bind(this);
        this.generateInstitutionChart = this.generateInstitutionChart.bind(this);
        this.getMembers = this.getMembers.bind(this);
        this.getByYouths = this.getByYouths.bind(this);

    }

    componentDidMount() {
        this.getByGender()
        this.getYouthsByGender()
        this.getBranches()
        this.getSectors()
        this.getInstitutions()
    }

    getMembers() {
        getAllMembers();

    }
    getByYouths() {
        getYouths();

    }
    getByGender() {
        const maleUrl = "/api/findbygender/M"
        const femaleUrl = "/api/findbygender/F"

        api.get(maleUrl).then((response) => {
            const data = response.data;
            this.setState({ male: data });

        });


        api.get(femaleUrl).then((response) => {
            const data = response.data;
            this.setState({ female: data });

        });

    }
    getYouthsByGender() {
        const maleUrl = "/api/findyouthsbygender/M"
        const femaleUrl = "/api/findyouthsbygender/F"

        api.get(maleUrl).then((response) => {
            const data = response.data;
            this.setState({ maleYouths: data });

        });


        api.get(femaleUrl).then((response) => {
            const data = response.data;
            this.setState({ femaleYouths: data });

        });

    }

    getBranches() {

        const url = "/api/findbybranch"

        api.get(url).then((response) => {
            const data = response.data;
            this.setState({ branchData: data });

        });

    }
    getSectors() {

        const url = "/api/findbysector"

        api.get(url).then((response) => {
            const data = response.data;
            this.setState({ sectorData: data });

        });

    }
    getInstitutions() {

        const url = "/api/findbyinstitution"

        api.get(url).then((response) => {
            const data = response.data;
            this.setState({ institutionData: data });

        });

    }


    generateBranchChart() {
        const branchData = this.state.branchData
        const labelData = branchData && branchData.map(branch => branch.label)
        const countData = branchData && branchData.map(branch => branch.counts)
        this.branchChartData = {

            labels: labelData,
            datasets: [
                {
                    data: countData,
                    label: 'Branch',
                    backgroundColor: 'rgb(255, 99, 132)',
                    borderColor: 'rgb(0, 255, 0)',
                    hoverBackgroundColor: "#FFCE56"


                }
            ]
        };

        this.branchLightOptions = {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }],
                yAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }]
            }

        };

    }


    generateSectorChart() {
        const sectorData = this.state.sectorData
        const labelData = sectorData && sectorData.map(sector => sector.label)
        const countData = sectorData && sectorData.map(sector => sector.counts)
        this.sectorChartData = {

            labels: labelData,
            datasets: [
                {
                    data: countData,
                    label: 'Sector',
                    backgroundColor: 'rgb(0, 0, 255)',
                    borderColor: 'rgb(0, 255, 0)',
                    hoverBackgroundColor: "#FFCE56"

                }
            ]
        };

        this.sectorLightOptions = {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }],
                yAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }]
            }

        };

    }

    generateInstitutionChart() {
        const institutionData = this.state.institutionData
        const labelData = institutionData && institutionData.map(institution => institution.label)
        const countData = institutionData && institutionData.map(institution => institution.counts)
        this.institutionChartData = {

            labels: labelData,
            datasets: [
                {
                    data: countData,
                    label: 'Institution',
                    backgroundColor: 'rgb(255, 0, 255)',
                    borderColor: 'rgb(0, 255, 0)',
                    hoverBackgroundColor: "#FFCE56"

                }
            ]
        };

        this.institutionLightOptions = {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }],
                yAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }]
            }

        };

    }

    generateGenderChart() {

        this.chartData = {
            labels: ['Male', 'Female'],
            datasets: [
                {
                    data: [this.state.male, this.state.female],
                    backgroundColor: [
                        "#42A5F5",
                        "#66BB6A"

                    ],
                    hoverBackgroundColor: [
                        "#FF6384",
                        "#FFCE56"

                    ]
                }
            ]
        };

        this.lightOptions = {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            }
        };


    }



    generateYouthsGenderChart() {

        this.youthChartData = {
            labels: ['Male', 'Female'],
            datasets: [
                {
                    data: [this.state.maleYouths, this.state.femaleYouths],
                    backgroundColor: [
                        "#FF6384",
                        "#FFCE56"

                    ],
                    hoverBackgroundColor: [
                        "#64B5F6",
                        "#81C784"

                    ]
                }
            ]
        };

        this.youthLightOptions = {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            }
        };


    }


    render() {
        this.generateInstitutionChart()
        this.generateSectorChart()
        this.generateBranchChart()
        this.generateGenderChart()
        this.generateYouthsGenderChart()


        return (
            <div className="container-fluid">
                <div className="row m-auto">
                    <div className="col-sm-6">
                        <div className="card mt-4 border-primary shadow-lg rounded">
                            <div className='card-header mb-3 '>
                                <h5 className="m-auto">Current Membership - {this.state.male + this.state.female}</h5>
                            </div>
                            {this.state.male > 0 && (<Chart type="pie" data={this.chartData} options={this.lightOptions} />)}
                            <div className="card-footer">

                                <Link> <span onClick={this.getMembers}>Download Membership list</span></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="card mt-4 border-primary shadow-lg rounded">
                            <div className='card-header mb-3'>
                                <h5 className="m-auto">Current Youths - {this.state.maleYouths + this.state.femaleYouths}</h5>

                            </div>
                            {this.state.maleYouths > 0 && (<Chart type="doughnut" data={this.youthChartData} options={this.youthLightOptions} />)}
                            <div className="card-footer">
                                <Link> <span onClick={this.getByYouths}>Download Youths list</span></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="card mt-4 border-primary shadow-lg rounded" >
                            <div className='card-header mb-3'>
                                <h5 className="m-auto">Branch Statistics</h5>
                            </div>
                            {this.state.branchData && (<Chart type="bar" data={this.branchChartData} options={this.branchLightOptions} />)}
                            {/* <div className="card-footer">Download Branch list</div> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card mt-4 border-primary shadow-lg rounded" >
                            <div className='card-header mb-3'>
                                <h5 className="m-auto">Sector Statistics</h5>
                            </div>
                            {this.state.sectorData && (<Chart type="bar" data={this.sectorChartData} options={this.sectorLightOptions} />)}
                            {/* <div className="card-footer">Download Sector list</div> */}
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mt-4 mb-4 border-primary shadow-lg rounded" >
                            <div className='card-header mb-3'>
                                <h5 className="m-auto">Institution Statistics</h5>
                            </div>
                            {this.state.institutionData && (<Chart type="bar" data={this.institutionChartData} options={this.institutionLightOptions} />)}
                            {/* <div className="card-footer">Download Institution list</div> */}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default Home;